<template>
    <transition :name="transitionName">
        <div v-show="step === currentStep" class="c-stepper-item">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        step: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            transitionName: "",
        };
    },
    watch: {
        currentStep(newValue, oldValue) {
            if (newValue > oldValue) {
                this.transitionName = "slide-left";
            } else {
                this.transitionName = "slide-right";
            }
        },
    },
    computed: {
        currentStep() {
            return this.$parent.value;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-stepper-item {
    position: absolute;
    width: 100%;
    padding-bottom: 20px;
}

.slide-left-enter {
    transform: translateX(100%);
    opacity: 0;
}
.slide-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}
.slide-right-enter {
    transform: translateX(-100%);
    opacity: 0;
}
.slide-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
}
.slide-left-enter-to,
.slide-left-leave,
.slide-right-enter-to,
.slide-right-leave {
    transform: translateX(0);
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.5s;
}
</style>
